module.exports = __webpack_public_path__ + "static/media/cert_4997.d120eac5.jpg";